import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Redirect } from 'react-router-dom';
import Switch from 'react-switch';
import Loading from '../ui/Loading.js';
import { useIntl } from 'react-intl';
import * as Utils from '../../commons/utils/Utils';
import Security from '../../commons/security/Security.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';

const ItemClasificacionesAbm = (props) => {
  const intl = useIntl();
  const [redirectTo, setRedirectTo] = useState(null);
  const [formData, setFormData] = useState({
    id: 0,
    nombre: '',
    activa: true,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (((Security.hasPermission('ITEMS_CLASIFICACIONES_CREAR') && props.action === 'ADD') ||
        (Security.hasPermission('ITEMS_CLASIFICACIONES_MODIFICAR') && props.action === 'EDIT') ||
        (Security.hasPermission('ITEMS_CLASIFICACIONES_VISUALIZAR') && props.action === 'VIEW')) &&
        ConfigBusiness.get('panol.items.clasificacion.habilitado') === 'true') {
      initForm();
    } else {
      setRedirectTo('/error');
    }
  }, [props.action, props.match && props.match.params && props.match.params.id]);

  const initForm = () => {
    setLoading(true);
    if (props.action !== 'ADD') {
      Utils.getData(`/item/clasificaciones/${props.match.params.id}`)
        .then(data => {
          if (data) setFormData(data);
          else exit();
        })
        .catch(() => exit())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  };

  const handleInputNombreChange = (e) => {
    e.persist();
    setFormData((prev) => ({
      ...prev,
      nombre: e.target.value,
    }));
  };

  const handleInputActivaChange = (estado) => {
    setFormData((prev) => ({
      ...prev,
      activa: estado,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    
    // Validate required fields
    if (!formData.nombre || !formData.nombre.trim()) {
      Swal.fire({
        icon: 'warning',
        title: intl.formatMessage({ id: 'itemClasificacionesAbm.error.nombre_required', defaultMessage: 'El nombre de la clasificación es requerido' }),
        confirmButtonText: 'OK'
      });
      return;
    }
    
    setLoading(true);
    
    // Si es modo EDIT y no tiene permiso de eliminación, no enviar el campo activa
    let dataToSend = { ...formData };
    if (props.action === 'EDIT' && !Security.hasPermission('ITEMS_CLASIFICACIONES_ELIMINAR')) {
      // No incluir el campo activa en la actualización
      delete dataToSend.activa;
    }
    
    Utils.sendData(`/item/clasificaciones${props.action !== 'ADD' ? '/' + formData.id : ''}`, props.action === 'ADD' ? 'POST' : 'PUT', dataToSend)
      .then(response => {
        if (response) {
          exit();
        }
      })
      .catch(err => {
        console.error(err);
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({ id: 'itemClasificacionesAbm.error.save_failed', defaultMessage: 'Error al guardar la clasificación' }),
          confirmButtonText: 'OK'
        });
      })
      .finally(() => setLoading(false));
  };

  const handleCancel = () => {
    exit();
  };

  const exit = () => {
    setRedirectTo('/item_clasificaciones');
  };

  return (
    <React.Fragment>
      {redirectTo && <Redirect push to={redirectTo} />}
      {loading && <Loading />}
      <div className="row">
        <div className="col-md-12">
          <form className="form form-horizontal">
            <div className="form-body">
              <div className="card pull-up">
                <div className="card-content">
                  <div className="card-body">
                    <h4 className="form-section">
                      <i className="icon-home"></i>
                      {intl.formatMessage({
                        id: 'itemClasificacionesAbm.render.general_data.header_datos_generales',
                        defaultMessage: 'Datos Generales',
                      })}
                      <div className="float-right" style={{ fontSize: '14px' }}>
                        * {intl.formatMessage({ id: 'itemClasificacionesAbm.render.general_data.campos_requeridos', defaultMessage: 'campos requeridos' })}
                      </div>
                    </h4>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-3 label-control col-form-label" htmlFor="nombre">
                            {intl.formatMessage({ id: 'itemClasificacionesAbm.render.general_data.nombre', defaultMessage: 'Clasificación' })}*:
                          </label>
                          <div className="col-md-9">
                            {props.action === 'VIEW' ? (
                              <div className="form-control-static col-form-label form-value">{formData.nombre}</div>
                            ) : (
                              <div>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="nombre"
                                  name="nombre"
                                  placeholder={intl.formatMessage({ id: 'itemClasificacionesAbm.render.general_data.nombre', defaultMessage: 'Clasificación' })}
                                  value={formData.nombre}
                                  onChange={handleInputNombreChange}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-md-3 label-control col-form-label" htmlFor="activa">
                          {intl.formatMessage({ id: 'itemClasificacionesAbm.render.general_data.activa', defaultMessage: 'Activa' })}
                        </label>
                        <div className="col-md-9">
                          <Switch
                            onChange={handleInputActivaChange}
                            checked={formData.activa ? true : false}
                            id="activa"
                            name="activa"
                            disabled={props.action === 'VIEW' || (props.action === 'EDIT' && !Security.hasPermission('ITEMS_CLASIFICACIONES_ELIMINAR'))}
                            offColor="#FF4961"
                            onColor="#28D094"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card pull-up">
                <div className="card-content">
                  <div className="card-body">
                    <div className="text-cd text-right">
                      {props.action !== 'VIEW' && (
                        <button onClick={handleSubmit} className="btn btn-primary mr-1">
                          <i className="fa fa-check-circle"></i>
                          {intl.formatMessage({ id: 'itemClasificacionesAbm.render.guardar', defaultMessage: 'Guardar' })}
                        </button>
                      )}
                      <button type="button" className="btn btn-danger" onClick={handleCancel}>
                        <i className="fa fa-times-circle"></i>{' '}
                        {props.action === 'VIEW'
                          ? intl.formatMessage({ id: 'itemClasificacionesAbm.render.volver', defaultMessage: 'Volver' })
                          : intl.formatMessage({ id: 'itemClasificacionesAbm.render.cancelar', defaultMessage: 'Cancelar' })}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ItemClasificacionesAbm;


